import React from 'react';
import styled from 'styled-components';
import img from '../../images/sad.png';
import MainButton from '../buttons/mainButton';

const Container = styled.div`
  h3 {
    color: #fff;
  }
`

const Header = styled.div`
  margin-bottom: 20px;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Image = styled.div`
  background-image: url(${img});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 280px;
  height: 300px;
  width: 300px;
`

const ButtonContainer = styled.div`
  margin: 50px 0px;
`

const ThankYou = (props) => (
  <Container>
    <Header>
      <h1>{props.copy.h1}</h1>
      <h3>{props.copy.h3}</h3>
    </Header>

    <Body>
      <Image />
      <h3>{props.copy.contact}</h3>
      <ButtonContainer>
        <MainButton
          label={props.copy.button}
          action={() => window.open(props.copy.contactLink)}
        />
      </ButtonContainer>
    </Body>
  </Container>
)

export default ThankYou
